import React, {
  useEffect,
  useState,
  useCallback,
} from "react";

import {
  withStyles,
  makeStyles,
} from "@material-ui/core/styles";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";

import {
  Button,
  Grid,
  TextField,
  IconButton,
  Box,
  Typography,
  Tooltip,
} from "@material-ui/core";

import AddIcon from "@material-ui/icons/Add";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import EditIcon from "@material-ui/icons/Edit";

import { useParams } from "react-router-dom";

import {
  exhibitionList,
} from "src/adminModel/privateSale";

// =====================================================
// STYLES
// =====================================================

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: "#fff",
    border: "1px solid #e5e5e5",
    borderRadius: 8,
    overflow: "hidden",
    boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
  },

  toolbar: {
    padding: theme.spacing(2, 2.5),
    backgroundColor: "#fafafa",
    borderBottom: "1px solid #eeeeee",
  },

  searchField: {
    backgroundColor: "#fff",

    "& .MuiOutlinedInput-root": {
      borderRadius: 6,
    },

    "& .MuiInputBase-input": {
      fontSize: 13,
    },

    "& .MuiInputLabel-root": {
      fontSize: 13,
    },
  },

  filterButton: {
    height: 40,
    minWidth: 100,
    borderRadius: 6,
    textTransform: "none",
    fontWeight: 600,
    boxShadow: "none",

    "&:hover": {
      boxShadow: "none",
    },
  },

  addButton: {
    height: 40,
    minWidth: 100,
    borderRadius: 6,
    textTransform: "none",
    fontWeight: 600,
    boxShadow: "none",

    "&:hover": {
      boxShadow: "none",
    },
  },

  tableContainer: {
    maxHeight: 650,
  },

  table: {
    minWidth: 1300,
  },

  tableRow: {
    "&:hover": {
      backgroundColor: "#fafafa",
    },
  },

  cellText: {
    maxWidth: 220,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: 13,
    color: "#444",
  },

  artistButton: {
    textTransform: "none",
    padding: 0,
    minWidth: 0,
    justifyContent: "flex-start",
    fontSize: 13,
    fontWeight: 600,
    color: "#1976d2",
  },

  editButton: {
    minWidth: 38,
    width: 38,
    height: 34,
    padding: 0,
    borderRadius: 5,
    boxShadow: "none",

    "&:hover": {
      boxShadow: "none",
    },
  },

  pagination: {
    padding: theme.spacing(1.5, 2),
    borderTop: "1px solid #eeeeee",
    backgroundColor: "#fafafa",
  },

  pageNumber: {
    minWidth: 70,
    textAlign: "center",
    fontSize: 13,
    fontWeight: 600,
    color: "#555",
  },

  emptyCell: {
    padding: "50px !important",
  },

  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

// =====================================================
// TABLE CELL
// =====================================================

const StyledTableCell = withStyles(() => ({
  head: {
    backgroundColor: "#f7f7f7",
    color: "#222",
    fontWeight: 600,
    fontSize: 11,
    padding: "12px 13px",
    borderBottom: "1px solid #d8d8d8",
    textTransform: "uppercase",
    letterSpacing: "0.2px",
    whiteSpace: "nowrap",
  },

  body: {
    fontSize: 12,
    padding: "11px 13px",
    color: "#444",
    borderBottom: "1px solid #e8e8e8",
    verticalAlign: "top",
  },
}))(TableCell);

// =====================================================
// COMPONENT
// =====================================================

export default function CustomizedTables() {
  const classes = useStyles();

  const { id } = useParams();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  const [start, setStart] = useState(0);
  const [getData, setGetdata] = useState([]);

  // ===================================================
  // PAGE CHANGE
  // ===================================================

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(
      +event.target.value
    );
    setPage(0);
  };

  // ===================================================
  // FETCH DATA
  // ===================================================

  const FetchAuction = useCallback(
    async (
      currentSearch = "",
      currentStart = 0,
      currentLimit = 1000
    ) => {
      setLoading(true);

      try {
        const results =
          await exhibitionList(
            id,
            currentSearch,
            currentStart,
            currentLimit
          );

        console.log(
          "results: ",
          results
        );

        if (
          results ===
          "No Record Found"
        ) {
          setGetdata([]);
        } else {
          setGetdata(
            Array.isArray(results)
              ? results
              : []
          );
        }
      } catch (error) {
        console.error(
          "Fetch Error:",
          error
        );

        setGetdata([]);
      } finally {
        setLoading(false);
      }
    },
    [id]
  );

  // ===================================================
  // INITIAL FETCH
  // ===================================================

  useEffect(() => {
    FetchAuction();
  }, [FetchAuction]);

  // ===================================================
  // SEARCH
  // ===================================================

  const handleClickSearch = () => {
    setStart(0);
    setPage(0);

    FetchAuction(
      search,
      0,
      1000
    );
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleClickSearch();
    }
  };

  // ===================================================
  // ADD
  // ===================================================

  const handleClickAdd = () => {};

  return (
    <Paper
      className={classes.root}
      elevation={0}
    >
      {/* =================================================
          TOOLBAR
      ================================================= */}

      <Box className={classes.toolbar}>
        <Grid
          container
          spacing={2}
          alignItems="center"
        >
          {/* SEARCH */}

          <Grid
            item
            md={4}
            sm={6}
            xs={12}
          >
            <TextField
              fullWidth
              size="small"
              type="text"
              label="Search"
              name="search"
              value={search}
              onChange={(e) =>
                setSearch(
                  e.target.value
                )
              }
              onKeyDown={
                handleKeyDown
              }
              placeholder="Search artist or title"
              variant="outlined"
              className={
                classes.searchField
              }
            />
          </Grid>

          {/* FILTER */}

          <Grid
            item
            md={2}
            sm={3}
            xs={12}
          >
            <Button
              fullWidth
              color="primary"
              variant="contained"
              onClick={
                handleClickSearch
              }
              className={
                classes.filterButton
              }
            >
              Filter
            </Button>
          </Grid>

          {/* ADD */}

          <Grid
            item
            md={2}
            sm={3}
            xs={12}
          >
            <Button
              fullWidth
              color="primary"
              variant="outlined"
              startIcon={
                <AddIcon />
              }
              href={`/app/exhibtion/add/item/${id}`}
              className={
                classes.addButton
              }
            >
              Add Item
            </Button>
          </Grid>
        </Grid>
      </Box>

      {/* =================================================
          TABLE
      ================================================= */}

      <TableContainer
        className={
          classes.tableContainer
        }
      >
        <Table
          stickyHeader
          aria-label="exhibition items"
          className={classes.table}
          size="small"
        >
          <TableHead>
            <TableRow>

              <StyledTableCell>
                Artist
              </StyledTableCell>

              <StyledTableCell>
                Title
              </StyledTableCell>

              <StyledTableCell>
                Signed / Dated
              </StyledTableCell>

              <StyledTableCell>
                Medium
              </StyledTableCell>

              <StyledTableCell>
                Size
              </StyledTableCell>

              <StyledTableCell>
                Property
              </StyledTableCell>

              <StyledTableCell>
                COA
              </StyledTableCell>

              <StyledTableCell>
                Provenance
              </StyledTableCell>

              <StyledTableCell>
                Exhibited
              </StyledTableCell>

              <StyledTableCell>
                Literature
              </StyledTableCell>

              <StyledTableCell>
                Write Up
              </StyledTableCell>

              <StyledTableCell>
                Lot Group
              </StyledTableCell>

              <StyledTableCell>
                Lot Details
              </StyledTableCell>

              <StyledTableCell>
                Alias
              </StyledTableCell>

              <StyledTableCell align="center">
                Action
              </StyledTableCell>

            </TableRow>
          </TableHead>

          <TableBody>
            {getData.length ? (
              getData
                .slice(
                  page *
                    rowsPerPage,
                  page *
                    rowsPerPage +
                    rowsPerPage
                )
                .map((row) => (
                  <TableRow
                    hover
                    key={row.id}
                    className={
                      classes.tableRow
                    }
                  >
                    {/* ARTIST */}

                    <StyledTableCell>
                      <Tooltip
                        title={
                          row.artist ||
                          ""
                        }
                        arrow
                      >
                        <Button
                          className={
                            classes.artistButton
                          }
                          href={`/app/exihibitions/edit/${encodeURIComponent(
                            row.title ||
                              "no-title"
                          )}/${row.id}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {row.artist ||
                            "---"}
                        </Button>
                      </Tooltip>
                    </StyledTableCell>

                    {/* TITLE */}

                    <StyledTableCell>
                      <Tooltip
                        title={
                          row.title ||
                          ""
                        }
                        arrow
                      >
                        <div
                          className={
                            classes.cellText
                          }
                        >
                          {row.title ||
                            "---"}
                        </div>
                      </Tooltip>
                    </StyledTableCell>

                    {/* SIGNED DATED */}

                    <StyledTableCell>
                      <div
                        className={
                          classes.cellText
                        }
                      >
                        {row.signed_dated ||
                          "---"}
                      </div>
                    </StyledTableCell>

                    {/* MEDIUM */}

                    <StyledTableCell>
                      <Tooltip
                        title={
                          row.medium ||
                          ""
                        }
                        arrow
                      >
                        <div
                          className={
                            classes.cellText
                          }
                        >
                          {row.medium ||
                            "---"}
                        </div>
                      </Tooltip>
                    </StyledTableCell>

                    {/* SIZE */}

                    <StyledTableCell>
                      <div
                        className={
                          classes.cellText
                        }
                      >
                        {row.size ||
                          "---"}
                      </div>
                    </StyledTableCell>

                    {/* PROPERTY */}

                    <StyledTableCell>
                      <Tooltip
                        title={
                          row.property ||
                          ""
                        }
                        arrow
                      >
                        <div
                          className={
                            classes.cellText
                          }
                        >
                          {row.property ||
                            "---"}
                        </div>
                      </Tooltip>
                    </StyledTableCell>

                    {/* COA */}

                    <StyledTableCell>
                      <Tooltip
                        title={
                          row.coa ||
                          ""
                        }
                        arrow
                      >
                        <div
                          className={
                            classes.cellText
                          }
                        >
                          {row.coa ||
                            "---"}
                        </div>
                      </Tooltip>
                    </StyledTableCell>

                    {/* PROVENANCE */}

                    <StyledTableCell>
                      <Tooltip
                        title={
                          row.provenance ||
                          ""
                        }
                        arrow
                      >
                        <div
                          className={
                            classes.cellText
                          }
                        >
                          {row.provenance ||
                            "---"}
                        </div>
                      </Tooltip>
                    </StyledTableCell>

                    {/* EXHIBITED */}

                    <StyledTableCell>
                      <Tooltip
                        title={
                          row.exhibited ||
                          ""
                        }
                        arrow
                      >
                        <div
                          className={
                            classes.cellText
                          }
                        >
                          {row.exhibited ||
                            "---"}
                        </div>
                      </Tooltip>
                    </StyledTableCell>

                    {/* LITERATURE */}

                    <StyledTableCell>
                      <Tooltip
                        title={
                          row.literature ||
                          ""
                        }
                        arrow
                      >
                        <div
                          className={
                            classes.cellText
                          }
                        >
                          {row.literature ||
                            "---"}
                        </div>
                      </Tooltip>
                    </StyledTableCell>

                    {/* WRITE UP */}

                    <StyledTableCell>
                      <Tooltip
                        title={
                          row.write_up ||
                          ""
                        }
                        arrow
                      >
                        <div
                          className={
                            classes.cellText
                          }
                        >
                          {row.write_up ||
                            "---"}
                        </div>
                      </Tooltip>
                    </StyledTableCell>

                    {/* LOT GROUP */}

                    <StyledTableCell>
                      <div
                        className={
                          classes.cellText
                        }
                      >
                        {row.lot_group ||
                          "---"}
                      </div>
                    </StyledTableCell>

                    {/* LOT DETAILS */}

                    <StyledTableCell>
                      <Tooltip
                        title={
                          row.lot_details_html ||
                          ""
                        }
                        arrow
                      >
                        <div
                          className={
                            classes.cellText
                          }
                        >
                          {row.lot_details_html ||
                            "---"}
                        </div>
                      </Tooltip>
                    </StyledTableCell>

                    {/* ALIAS */}

                    <StyledTableCell>
                      <div
                        className={
                          classes.cellText
                        }
                      >
                        {row.alias ||
                          "---"}
                      </div>
                    </StyledTableCell>

                    {/* ACTION */}

                    <StyledTableCell align="center">
                      <Tooltip
                        title="Edit Item"
                        arrow
                      >
                        <Button
                          className={
                            classes.editButton
                          }
                          color="primary"
                          variant="contained"
                          href={`/app/exihibitions/edit/${encodeURIComponent(
                            row.title ||
                              "no-title"
                          )}/${row.id}`}
                        >
                          <EditIcon fontSize="small" />
                        </Button>
                      </Tooltip>
                    </StyledTableCell>

                  </TableRow>
                ))
            ) : (
              <TableRow>
                <StyledTableCell
                  colSpan={15}
                  align="center"
                  className={
                    classes.emptyCell
                  }
                >
                  <Typography
                    variant="body2"
                    color="textSecondary"
                  >
                    {loading
                      ? "Loading items..."
                      : "No exhibition items found."}
                  </Typography>
                </StyledTableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* =================================================
          PAGINATION
      ================================================= */}

      <Box
        className={
          classes.pagination
        }
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <IconButton
          disabled={
            page === 0 ||
            loading
          }
          onClick={() =>
            setPage(
              page - 1
            )
          }
          size="small"
        >
          <ArrowBackIosIcon fontSize="inherit" />
        </IconButton>

        <Typography
          className={
            classes.pageNumber
          }
        >
          Page {page + 1}
        </Typography>

        <IconButton
          disabled={
            loading ||
            page >=
              Math.ceil(
                getData.length /
                  rowsPerPage
              ) -
                1
          }
          onClick={() =>
            setPage(
              page + 1
            )
          }
          size="small"
        >
          <ArrowForwardIosIcon fontSize="inherit" />
        </IconButton>
      </Box>

      {/* =================================================
          LOADING
      ================================================= */}

      <Backdrop
        className={
          classes.backdrop
        }
        open={loading}
      >
        <CircularProgress
          color="inherit"
        />
      </Backdrop>
    </Paper>
  );
}